import React from 'react';
import { PixelRatio } from 'react-native';
import { Image, isWeb, LabelRegular, YStack } from 'smoothie';

import {
    Header,
    InvestingDisclosures,
    LinearGradientBackgroundCard,
    Section,
} from './shared';
import { SlideNextButton } from './SlideNextButton';

// On native, Metro auto-resolves @2x/@3x from the base filename.
// On web, we select the variant manually based on device pixel ratio.
const InvestmentsImageSource =
    isWeb && PixelRatio.get() >= 2
        ? require('../../assets/images/investments-2x.png')
        : require('../../assets/images/investments.png');

const InvestmentsOverviewSlide = () => {
    return (
        <YStack gap={24}>
            <LinearGradientBackgroundCard>
                <YStack
                    gap={24}
                    paddingBottom={24}
                    width="100%"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Header
                        title="Investments at Fruitful"
                        description="How we manage your money to keep things simple"
                    />

                    <Section
                        title="Managed for you to keep things simple"
                        body="Investing at Fruitful takes time-tested strategies and makes them available to anyone, no finance degree required. We build you a globally diversified portfolio of low-cost index funds and manage it for you: monitoring daily to keep your risk level on target, reinvesting dividends, and routing any extra income from your money system straight into your investments. So your money stays consistently invested instead of sitting idle."
                    />
                    <Image
                        source={InvestmentsImageSource}
                        style={{ width: 352, height: 313, marginBottom: -32 }}
                    />
                    <LabelRegular color="$gray1000">
                        Images shown for illustrative purposes only. All
                        investing involves risk, including the risk of losing
                        the money you invest, and past performance does not
                        guarantee future performance.
                    </LabelRegular>
                    <Section
                        title="Tax-loss harvesting and automated rebalancing"
                        body="Two features that work in your favor behind the scenes. When part of your portfolio drops in value, tax-loss harvesting lets our team sell it to capture the loss, then reinvest in a similar position. Those losses can help offset your capital gains and ordinary income taxes. With automated rebalancing, we monitor your portfolio and rebalance it regularly so it stays aligned with your goals."
                    />
                    <Section body="Neither one needs anything from you, and together they help reduce the tax drag on your returns over time." />
                </YStack>

                <SlideNextButton />
            </LinearGradientBackgroundCard>

            <InvestingDisclosures includeTaxDisclosure />
        </YStack>
    );
};

export default InvestmentsOverviewSlide;
